import { Sparkles } from "lucide-react"
import { createElement } from "react"

import type { PluginManifest } from "../types"
import { isPluginEnabled } from "../utils"
import { ComingSoonBadge } from "@/components/ComingSoonBadge"

const enabled = isPluginEnabled("gradeai")

export const gradeAIPlugin: PluginManifest = {
  id: "gradeai",
  name: "Grade AI",
  description: "Automated grading workflows with multimodal evaluation",
  route: enabled ? "/plugins/gradeai" : undefined,
  availability: enabled ? "enabled" : "comingSoon",
  icon: Sparkles,
  order: 2,
  badge: enabled ? undefined : createElement(ComingSoonBadge),
  loadPage: enabled
    ? () => import("./pages/GradeAIPage")
    : undefined,
}
